import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const { dropdown } = semanticThemeTokens;

export const popoverContent = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["4x"],
  minWidth: "var(--radix-popover-trigger-width)",
  padding: primitiveTokens.sizing["4x"],
  backgroundColor: dropdown.content.backgroundColor,
  color: dropdown.content.color,
  fontSize: primitiveTokens.type.sm,
  borderRadius: primitiveTokens.radii.sm,
  boxShadow: primitiveTokens.colors.shadow.popover,
  backdropFilter: "blur(8px)",
  outline: "none",
  // Matches the select popover, so a select opened inside a panel isn't
  // trapped behind it and neither is clipped by the sheet.
  zIndex: 1050
});
